(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kl-home-setup"] && !Shopify.designMode) return;
  try {
    
  class KLSetup extends HTMLElement {
    connectedCallback() {
      this.zero = this.dataset.zero || '0,00';
      this.addEventListener('change', () => this.#update());
      this.querySelector('[data-kz-add]')?.addEventListener('click', () => this.#add());
      this.#update();
    }

    /**
     * Liest je Zeile die gewählte Variante und deren Preis in Cent.
     * @returns {Array<Object>} je Zeile: line, id, price
     */
    #lines() {
      const lines = [];
      for (const line of this.querySelectorAll('[data-kz-line]')) {
        const select = line.querySelector('select');
        const source = select ? select.options[select.selectedIndex] : line;
        lines.push({ line, id: Number(source.dataset.variant), price: Number(source.dataset.price) });
      }
      return lines;
    }

    /** @param {number} cents */
    #format(cents) {
      const separator = this.zero.match(/0([,.])00/)?.[1] || ',';
      const amount = (cents / 100).toFixed(2).replace('.', separator);
      return this.zero.replace(/0[,.]00/, amount);
    }

    #update() {
      let total = 0;
      for (const { line, price } of this.#lines()) {
        total += price;
        const label = line.querySelector('[data-kz-price]');
        if (label) label.textContent = this.#format(price);
      }
      const output = this.querySelector('[data-kz-total]');
      if (output) output.textContent = this.#format(total);
    }

    async #add() {
      const button = this.querySelector('[data-kz-add]');
      const status = this.querySelector('[data-kz-status]');
      const items = this.#lines().map(({ id }) => ({ id, quantity: 1 }));
      if (!button || items.length === 0) return;

      const label = button.textContent;
      button.disabled = true;
      button.textContent = 'Wird hinzugefügt …';
      if (status) status.textContent = '';

      try {
        await window.KLCart.add(items);
        if (status) status.textContent = 'Dein Setup liegt im Warenkorb.';
      } catch (error) {
        if (status) status.textContent = 'Das hat nicht geklappt. Bitte versuche es über die Produktseiten.';
      } finally {
        button.disabled = false;
        button.textContent = label;
      }
    }
  }

  if (!customElements.get('kl-setup')) customElements.define('kl-setup', KLSetup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kl-home-shelf"] && !Shopify.designMode) return;
  try {
    
  class KLTabs extends HTMLElement {
    /** @type {HTMLElement[]} */
    #tabs = [];
    /** @type {HTMLElement[]} */
    #panels = [];

    connectedCallback() {
      const list = this.querySelector('[role="tablist"]');
      this.#tabs = [...this.querySelectorAll('[role="tab"]')];
      this.#panels = [...this.querySelectorAll('[role="tabpanel"]')];
      if (!list || this.#tabs.length < 2) return;

      list.hidden = false;
      list.addEventListener('keydown', this.#onKeydown);
      for (const tab of this.#tabs) {
        tab.addEventListener('click', () => this.#select(tab, false));
      }
      this.#select(this.#tabs[0], false);
    }

    /**
     * @param {HTMLElement} selected
     * @param {boolean} focus
     */
    #select(selected, focus) {
      for (const [index, tab] of this.#tabs.entries()) {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        this.#panels[index].hidden = !active;
      }
      if (focus) selected.focus();
    }

    /** @param {KeyboardEvent} event */
    #onKeydown = (event) => {
      const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
      if (!keys.includes(event.key)) return;
      event.preventDefault();

      const last = this.#tabs.length - 1;
      const current = this.#tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
      let next = current;
      if (event.key === 'ArrowRight') next = current === last ? 0 : current + 1;
      if (event.key === 'ArrowLeft') next = current === 0 ? last : current - 1;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = last;
      this.#select(this.#tabs[next], true);
    };
  }

  if (!customElements.get('kl-tabs')) customElements.define('kl-tabs', KLTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
